module.exports = __webpack_public_path__ + "images/cov-04-faq-desktop.png";